(function ($, Drupal, drupalSettings, once) {
  "use strict";

  Drupal.behaviors.hslPlansForm = {
    attach: function (context, settings) {
      const elements = once(
        "hslPlansForm",
        "#hsl-plans-form-container",
        context,
      );

      elements.forEach(function (element) {
        const $container = $(element);
        initForm($container);
      });
    },
  };

  function initForm($container) {
    const formHtml = `
      <div class="w-full">
        <div class="space-y-6">
          <section class="grid grid-cols-1 gap-6">
            <div class="flex flex-col">
              <label for="plans-state" class="text-sm font-semibold text-gray-700 mb-2">Estado</label>
              <select id="plans-state" class="w-full bg-transparent border-0 border-b border-gray-300 rounded-none px-0 py-2 text-sm text-gray-900 focus:outline-none focus:ring-0 focus:border-blue-600 transition-colors">
                <option value="">Selecione o estado</option>
              </select>
            </div>
            <div class="flex flex-col">
              <label for="plans-insurance" class="text-sm font-semibold text-gray-700 mb-2">Convênio</label>
              <select id="plans-insurance" class="w-full bg-transparent border-0 border-b border-gray-300 rounded-none px-0 py-2 text-sm text-gray-900 focus:outline-none focus:ring-0 focus:border-blue-600 transition-colors disabled:text-gray-400" disabled>
                <option value="">Selecione o convênio</option>
              </select>
            </div>
            <div id="container-category" class="flex flex-col hidden">
              <label for="plans-category" class="text-sm font-semibold text-gray-700 mb-2">Categoria</label>
              <select id="plans-category" class="w-full bg-transparent border-0 border-b border-gray-300 rounded-none px-0 py-2 text-sm text-gray-900 focus:outline-none focus:ring-0 focus:border-blue-600 transition-colors disabled:text-gray-400" disabled>
                <option value="">Selecione a categoria</option>
              </select>
            </div>
            <div id="container-plan" class="flex flex-col hidden">
              <label for="plans-plan" class="text-sm font-semibold text-gray-700 mb-2">Plano</label>
              <select id="plans-plan" class="w-full bg-transparent border-0 border-b border-gray-300 rounded-none px-0 py-2 text-sm text-gray-900 focus:outline-none focus:ring-0 focus:border-blue-600 transition-colors disabled:text-gray-400" disabled>
                <option value="">Selecione o plano</option>
              </select>
            </div>
          </section>
          <div class="pt-2">
            <button id="plans-search-btn" class="w-full rounded-md bg-blue-600 px-4 py-3 text-sm font-bold text-white hover:bg-blue-700 transition-all duration-200 shadow-sm disabled:bg-gray-300 disabled:cursor-not-allowed" disabled>
              PESQUISAR PLANO DE SAÚDE
            </button>
          </div>
          <div id="plans-results" class="hidden pt-4"></div>
        </div>
      </div>
    `;

    $container.html(formHtml);

    const $stateSelect = $("#plans-state");
    const $insuranceSelect = $("#plans-insurance");
    const $categorySelect = $("#plans-category");
    const $planSelect = $("#plans-plan");
    const $containerCategory = $("#container-category");
    const $containerPlan = $("#container-plan");
    const $searchBtn = $("#plans-search-btn");
    const $results = $("#plans-results");

    /**
     * Clears and hides the results container.
     * This ensures no outdated results remain visible
     * when the user changes any form field.
     */
    function clearResults() {
      $results.addClass("hidden").empty();
    }

    // Initial load of states
    loadOptions(
      "/api/plans/states?_format=json",
      $stateSelect,
      "SIGLA",
      "NOME",
    );

    $stateSelect.on("change", function () {
      clearResults(); // Clear results on state change

      const state = $(this).val();
      resetSelect($insuranceSelect, "Selecione o convênio");
      resetSelect($categorySelect, "Selecione a categoria");
      $containerCategory.addClass("hidden");
      resetSelect($planSelect, "Selecione o plano");
      $containerPlan.addClass("hidden");
      $searchBtn.prop("disabled", true);

      if (state) {
        loadOptions(
          "/api/plans/insurances?_format=json",
          $insuranceSelect,
          "CODIGO",
          "DESCRICAO",
        );
      }
    });

    $insuranceSelect.on("change", function () {
      clearResults(); // Clear results on insurance change

      const insuranceId = $(this).val();
      resetSelect($categorySelect, "Selecione a categoria");
      $containerCategory.addClass("hidden");
      resetSelect($planSelect, "Selecione o plano");
      $containerPlan.addClass("hidden");
      $searchBtn.prop("disabled", true);

      if (insuranceId) {
        loadOptions(
          `/api/plans/categories?insuranceId=${insuranceId}&_format=json`,
          $categorySelect,
          "CODIGO",
          "DESCRICAO",
          function () {
            $containerCategory.removeClass("hidden");
          },
        );
      }
    });

    $categorySelect.on("change", function () {
      clearResults(); // Clear results on category change

      const categoryId = $(this).val();
      const insuranceId = $insuranceSelect.val();
      resetSelect($planSelect, "Selecione o plano");
      $containerPlan.addClass("hidden");
      $searchBtn.prop("disabled", true);

      if (categoryId && insuranceId) {
        loadOptions(
          `/api/plans/plans?insuranceId=${insuranceId}&categoryId=${categoryId}&_format=json`,
          $planSelect,
          "CODIGO",
          "DESCRICAO",
          function () {
            $containerPlan.removeClass("hidden");
          },
        );
      }
    });

    $planSelect.on("change", function () {
      clearResults(); // Clear results on plan change
      $searchBtn.prop("disabled", !$(this).val());
    });

    $searchBtn.on("click", function (e) {
      e.preventDefault();

      const state = $stateSelect.val();
      const stateText = $stateSelect.find("option:selected").text();
      const insuranceId = $insuranceSelect.val();
      const insuranceText = $insuranceSelect.find("option:selected").text();
      const categoryId = $categorySelect.val();
      const categoryText = $categorySelect.find("option:selected").text();
      const insurancePlanId = $planSelect.val();
      const planText = $planSelect.find("option:selected").text();

      if (!state || !insuranceId || !categoryId || !insurancePlanId) {
        alert("Por favor, selecione todos os campos.");
        return;
      }

      $results
        .removeClass("hidden")
        .html(
          "<div class='flex items-center justify-center p-8'><p class='text-gray-500 animate-pulse'>Buscando informações de cobertura...</p></div>",
        );

      let searchParams =
        `?state=${state}` +
        `&stateLabel=${encodeURIComponent(stateText)}` +
        `&insuranceId=${insuranceId}` +
        `&insuranceLabel=${encodeURIComponent(insuranceText)}` +
        `&categoryId=${categoryId}` +
        `&categoryLabel=${encodeURIComponent(categoryText)}` +
        `&insurancePlanId=${insurancePlanId}` +
        `&planLabel=${encodeURIComponent(planText)}`;

      fetch(`/plans/ajax${searchParams}`)
        .then((r) => r.json())
        .then((data) => {
          if (data.html) {
            $results.html(data.html);
          }
        })
        .catch(() => {
          $results.html(
            "<p class='text-red-500'>Erro ao buscar informações.</p>",
          );
        });
    });
  }

  function loadOptions(url, $select, valueKey, labelKey, callback) {
    const originalText = $select.find("option:first").text();
    $select.prop("disabled", true).find("option:first").text("Carregando...");

    const cacheBuster = new Date().getTime();
    const separator = url.includes("?") ? "&" : "?";
    const urlWithCacheBuster = `${url}${separator}cb=${cacheBuster}`;

    fetch(urlWithCacheBuster, {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const items = data?.result ?? [];
        let options = `<option value="">${originalText}</option>`;
        items.forEach((item) => {
          options += `<option value="${item[valueKey]}">${item[labelKey]}</option>`;
        });
        $select.html(options).prop("disabled", false);
        if (callback) callback();
      })
      .catch((error) => {
        console.error("Error loading options:", error);
        $select.find("option:first").text("Erro ao carregar");
        $select.prop("disabled", false);
      });
  }

  function resetSelect($select, defaultText) {
    $select
      .html(`<option value="">${defaultText}</option>`)
      .prop("disabled", true);
  }
})(jQuery, Drupal, drupalSettings, once);
